import { MaterialIcons } from "@expo/vector-icons";
import { Divider, HStack, Icon, Text, VStack } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";

type StepCardProps = {
  title: string;
  description?: string;
  icon?: JSX.Element;
  buttonTitle: string;
  hasError: boolean;
  onChange: () => void;
};

const StepCard = ({ title, description, icon, buttonTitle, hasError, onChange }: StepCardProps) => {
  return (
    <VStack my="2" p="2" bgColor="white.50" shadow="4" rounded="md">
      <Text fontSize="lg" bold>
        {title}
      </Text>
      <Divider my="2" />
      <HStack justifyContent="space-between" alignItems="center">
        <HStack space="2" alignItems="center">
          {!!icon && <Icon as={icon} color="primary.600" size="lg" />}
          {hasError ? (
            <Text color="error.400">Campo obrigatório</Text>
          ) : (
            <Text>{description || ""}</Text>
          )}
        </HStack>
        <FormButton
          variant="solid"
          colorScheme="white"
          _text={{
            color: "primary.600",
            fontWeight: "bold",
            fontSize: {
              base: "sm",
              lg: "sm",
            },
          }}
          rightIcon={
            <Icon as={<MaterialIcons name="arrow-forward-ios" />} color="primary.600" size="sm" />
          }
          onPress={onChange}>
          {description ? "Alterar" : buttonTitle}
        </FormButton>
      </HStack>
    </VStack>
  );
};

export default StepCard;
